// extracted by mini-css-extract-plugin
export var option = "_5u-0";
export var optionCard = "_5u-f";
export var optionContent = "_5u-g";
export var optionIcon = "_5u-i";
export var optionIconBox = "_5u-h";
export var optionLabel = "_5u-j";
export var optionPill = "_5u-m";
export var optionPillBadge = "_5u-p";
export var optionPillIcon = "_5u-n";
export var optionPillLabel = "_5u-o";
export var optionRadio = "_5u-k";
export var optionRadioInner = "_5u-l";
export var optionReveal = "_5u-2";
export var optionRevealDelay0 = "_5u-3";
export var optionRevealDelay1 = "_5u-4";
export var optionRevealDelay10 = "_5u-d";
export var optionRevealDelay11 = "_5u-e";
export var optionRevealDelay2 = "_5u-5";
export var optionRevealDelay3 = "_5u-6";
export var optionRevealDelay4 = "_5u-7";
export var optionRevealDelay5 = "_5u-8";
export var optionRevealDelay6 = "_5u-9";
export var optionRevealDelay7 = "_5u-a";
export var optionRevealDelay8 = "_5u-b";
export var optionRevealDelay9 = "_5u-c";
export var optionSelected = "_5u-1";